import { Compass, Navigation, Shuffle, Lock } from "lucide-react";
import { DeptIcon } from "@/components/DeptIcon";
import { PANEL_POLICY } from "@/components/LockNotice";

const MODES = [
  { key: "libera", label: "Esplorazione libera", icon: Compass },
  { key: "guidata", label: "Navigazione guidata", icon: Navigation },
  { key: "ibrida", label: "Modalità ibrida", icon: Shuffle },
];

export function ModeSwitcher({ mode, setMode }) {
  return (
    <div data-testid="nav-mode-selector" className="glass flex rounded-full p-1">
      {MODES.map((m) => (
        <button key={m.key} data-testid={`nav-mode-${m.key}`} onClick={() => setMode(m.key)} title={m.label}
          className={`flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold transition-colors ${mode === m.key ? "bg-sky-600 text-white" : "text-slate-600 hover:text-sky-700"}`}>
          <m.icon className="h-3.5 w-3.5" /><span className="hidden lg:inline">{m.label}</span>
        </button>
      ))}
    </div>
  );
}

function DockItem({ d, access, onPick, active }) {
  const pol = access?.policies?.[PANEL_POLICY[d.panel_type]];
  const locked = pol && !pol.allowed;
  return (
    <button data-testid={`dock-dept-${d.slug}`} onClick={() => onPick(d)} title={locked ? `${d.title} — ${pol.missing.map((m) => m.label).join(" · ")}` : d.title}
      aria-label={d.title} className={`flex shrink-0 items-center gap-1.5 rounded-lg px-2 py-1.5 text-left text-[11px] font-semibold transition-colors ${active ? "bg-cyan-100 text-cyan-900" : "text-slate-700 hover:bg-sky-50"}`}>
      <DeptIcon name={d.icon} className="h-4 w-4 text-sky-600" />
      <span className="hidden whitespace-nowrap sm:inline">{d.title}</span>
      {locked && <Lock className="h-3 w-3 text-amber-600" data-testid={`dock-lock-${d.slug}`} />}
    </button>
  );
}

export function DepartmentDock({ departments, access, onPick, target }) {
  return (
    <div data-testid="department-dock" className="glass flex flex-col gap-0.5 rounded-xl p-1 opacity-90 transition-opacity hover:opacity-100">
      {departments.map((d) => <DockItem key={d.id} d={d} access={access} onPick={onPick} active={target === d.slug} />)}
    </div>
  );
}
